export const salutationsMasters: string[] = ['Mr.', 'Ms.', 'M/S.', 'Mrs.'];
export const applicantStatusMasters: { [key: string]: string } = {
  Individual: 'Individual (Resident)',
  NRI: 'Individual (NRI)',
  NRI_PIO: 'NRI (PIO/OCI)',
  FOREIGN_NATIONAL: 'Foreign National',
};
export const nationalitiesMasters: string[] = ['Indian', 'Others'];
export const occupationDetailsMasters: string[] = [
  'PVT.SECTOR SERVICE',
  'PUBLIC SECTOR',
  'GOVT.SERVICE',
  'HOUSEWIFE',
  'PROFESSIONAL',
  'RETIRED',
  'BUSINESS',
  'AGRICULTURE',
  'STUDENT',
  'OTHERS',
];
export const occupationDetailsOutboundMasters: string[] = [
  'BUSINESS',
  'SERVICE',
  'PROFESSIONAL',
  'AGRICULTURIST',
  'HOUSEWIFE',
  'STUDENT',
  'DEFENCE',
  'BUREAUCRAT',
  'FOREX DEALER',
  'UNLISTED COMPANY',
  'BODY CORPORATE',
  'LISTED COMPANY',
  'OTHERS',
];

export const indiaOpportunitiesFundOccupationMaster: string[] = [
  'BUSINESS',
  'SERVICE',
  'PROFESSIONAL',
  'AGRICULTURIST',
  'HOUSEWIFE',
  'STUDENT',
  'DEFENCE',
  'BUREAUCRAT',
  'FOREX DEALER',
  'UNLISTED COMPANY',
  'BODY CORPORATE',
  'LISTED COMPANY',
  'OTHERS',
];

export const grossAnnualMasters: { [key: string]: string[] } = {
  domestic: [
    'BELOW 1 LAC',
    '1-5 LAC',
    '5-10 LACS',
    '10-25 LACS',
    '>25 LACS - 1 CRORE',
    '> 1 CRORE',
  ],
  foreign: [
    'Upto 150,000',
    '150,000 - 250,000',
    '250,000 - 350,000',
    '350,000 - 450,000',
    '450,000 - 550,000',
    '> 550,000',
  ],
};

export const PEPsMasters: string[] = ['I am PEP', 'I am Related to PEP', 'Not Applicable'];

export const addressTypesMasters: string[] = [
  'Resident/Business',
  'Resident',
  'Business',
  'Registered Office',
  'Unspecified',
];
export const addressTypesMastersforoutbound: string[] = [
  'Resident/Business',
  'Residential',
  'Business',
  'Registered Office',
];

export const genderMasters: string[] = ['Male', 'Female', 'Others'];

export const IdentityProofsMasters: string[] = [
  'Photo PAN Card',
  'Passport',
  "Voter's ID",
  'Driving License',
  'Aadhar Card',
];

export const AddressProofsMasters: string[] = [
  'Passport',
  "Voter's ID",
  'Ration Card',
  'Electricity Bill',
  'Landline/Telephone Bill',
  'Gas Bill',
  'Latest Bank Statement/Passbook',
  'Latest Depository Account Statement',
];

export const BankAccountProofsMasters: string[] = [
  'Bank Statement with IFSC printed on it',
  'Cancelled cheque leaf verified',
  'Letter from the bank giving account details',
  'Passbook (showing bank account details)',
];

export const DrawDownMasters: number[] = [1, 2, 3, 4];

export const filterApplicationTypes = [
  { key: 'individual', value: 'Individual' },
  { key: 'non_individual', value: 'Non-Individual' },
  // { key: 'minor', value: 'Minor' },
];

export const ModeOfHoldingTypes = [
  { key: 'single', value: 'Single' },
  { key: 'either or survivor,joint', value: 'Joint' },
];

export const IMAGE_UPLOAD_FORMATS = ['image/jpeg', 'application/pdf', 'image/png', 'image/jpg'];

export const INVESTOR_IMAGE_UPLOAD_FORMATS = ['image/png', 'image/jpg', 'image/jpeg'];

export const APPLICATION_STATUS: { [key: string]: string } = {
  draft: 'Draft',
  sent_to_applicant1: 'Sent to 1st applicant',
  approved_by_applicant1: 'Approved by 1st Applicant',
  approved_by_applicant2: 'Approved by 2nd Applicant',
  approved_by_applicant3: 'Approved by 3rd Applicant',
  approved_by_trustee: 'Approved by Trustee',
  approved_by_fundmanager: 'Approved by investment manager',
  invitationexpired: 'Invitation Expired',
  completed: 'Completed',
  signed: 'Completed',
  rejected: 'Rejected',
};

export const SUPPORT_STATUS: { [key: string]: string } = {
  sent_to_applicant1: 'Sent to 1st applicant',
  approved_by_applicant1: 'Approved by 1st Applicant',
  approved_by_applicant2: 'Approved by 2nd Applicant',
  approved_by_applicant3: 'Approved by 3rd Applicant',
  approved_by_fundmanager: 'Approved by investment manager',
  sent_to_authorised_signatories: 'Sent to authorised signatories',
  approved_by_authorised_signatories: 'Approved by authorised signatories',
};
export const subdistributorTypes: { [key: string]: string } = {
  direct: 'Distributor RM',
  support: 'CSE',
};
export const POA_APPLICATION_STATUS: { [key: string]: string } = {
  draft: 'Draft',
  sent_to_poa_approver: 'Sent to POA approver',
  sent_to_amc_approver: 'Sent to GIFT City Approver',
  sent_to_authorised_signatories: 'Sent to authorised signatories',
  approved_by_authorised_signatories: 'Approved by authorised signatories',
  approved_by_fundmanager: 'Approved by investment manager',
  approved_by_trustee: 'Approved by trustee',
  invitationexpired: 'Invitation Expired',
  signed: 'Completed',
  completed: 'Completed',
  rejected: 'Rejected',
};

export const ESIGN_STATUS: { [key: string]: string } = {
  NOT_GENERATED: 'notgenerated',
  PENDING_SIGNATURE: 'pendingsignature',
  SIGNED: 'signed',
  EXPIRED: 'expired',
  COMPLETED: 'completed',
};

export enum USER_ROLES {
  SUPER_ADMIN = 'superadmin',
  AMC_ADMIN = 'amcadmin',
  RM = 'rm',
  DISTRIBUTOR = 'distributor',
  INVESTOR = 'investor',
  FUND_MANAGER = 'fundmanager',
  TRUSTEE = 'trustee',
  WITNESS = 'witness',
  APPLICATION = 'application',
  SUBDISTRIBUTOR = 'subdistributor',
  POAAPPROVER = 'poaapprover',
  AMCAPPROVER = 'amcapprover',
  AUTHORISEDSIGNATORY = 'authorisedsignatory',
  // RTAAPPROVER = 'rtaapprover',
}

export const ApplicationStatusBasedOnRole: { [key: string]: { [key: string]: string } } = {
  [USER_ROLES.POAAPPROVER]: {
    ...POA_APPLICATION_STATUS,
    sent_to_poa_approver: 'Pending',
  },
  [USER_ROLES.AMCAPPROVER]: {
    ...POA_APPLICATION_STATUS,
    sent_to_amc_approver: 'Pending',
  },
};

export const Relations = [
  'Mother',
  'Father',
  'Daughter',
  'Son',
  'Spouse',
  'Brother',
  'Sister',
  'Others',
];
export const RelationsXalt = ['Mother', 'Father', 'Daughter', 'Son', 'Spouse', 'Brother', 'Sister'];

export const NomineeRelations = [
  'MOTHER',
  'FATHER',
  'DAUGHTER',
  'SON',
  'SPOUSE',
  'BROTHER',
  'SISTER',
  'OTHERS',
];
export const NomineeRelationsXalt = [
  'MOTHER',
  'FATHER',
  'DAUGHTER',
  'SON',
  'SPOUSE',
  'BROTHER',
  'SISTER',
];

export const adminSupportMaster: { [key: string]: string } = {
  unlock_user: 'Unlock User',
  check_whitelisted: 'Check Whitelisted',
  whitelist_user: 'Whitelist User',
  unwhitelist_user: 'Unwhitelist User',
  change_expired_status: 'Change Expired Status',
  change_status_to_draft: 'Change Status to draft',
};

export const AML_ALL_DISPLAY_MODE = false; // true = show all matches, false = show first match only

export const IS_DOB_APPLICABLE_FOR_AMC = true;

export const REJECTED_ROLES: { [key: string]: string } = {
  poaapprover: 'POA Approver',
  amcapprover: 'GIFT City Approver',
};

export const investorTypeMasters: { [key: string]: string } = {
  private_company: 'Private Company',
  partnership: 'Partnership',
  public_ltd_co: 'Public Ltd Co',
  trust: 'Trust',
};
export const investorTypeOutboundMasters: { [key: string]: string } = {
  private_company: 'Private Company',
  partnership: 'Partnership Firm',
  public_ltd_co: 'Public Ltd Co',
  llp: 'LLP',
  trust: 'Trust',
};

export const IS_PENNYDROP_APPLICABLE_FOR_AMC = true;

export const getGroupNameMaster = ['Group-A', 'Group-B', 'Group-C'];

export const NON_INDIVIDUAL_APPLICATION_STATUS: { [key: string]: string } = {
  draft: 'Draft',
  sent_to_amc_approver: 'Sent to GIFT City Approver',
  sent_to_authorised_signatories: 'Sent to authorised signatories',
  approved_by_authorised_signatories: 'Approved by authorised signatories',
  approved_by_fundmanager: 'Approved by investment manager',
  approved_by_trustee: 'Approved by trustee',
  invitationexpired: 'Invitation Expired',
  signed: 'Completed',
  completed: 'Completed',
  rejected: 'Rejected',
};

export const CpUboCodesMaster: { [key: string]: string } = {
  C01: '- CP of legal person-ownership',
  C02: '- CP of legal person-other means',
  C03: '- CP of legal person-senior managing official',
  C04: '- CP of legal arrangement-trust-settlor',
  C05: '- CP of legal arrangement-trust-trustee',
  C06: '- CP of legal arrangement-trust-protector',
  C07: '- CP of legal arrangement-trust-beneficiary',
  C08: '- CP of legal arrangement-trust-other',
  C09: '- CP of legal arrangement-trust-other-settlor-equivalent',
  C10: '- CP of legal arrangement-trust-other-trustee-equivalent',
  C11: '- CP of legal arrangement-trust-other-protector-equivalent',
  C12: '- CP of legal arrangement-trust-other-beneficiary-equivalent',
  C13: '- CP of legal arrangement-trust-other-other-equivalent',
  C14: '- Unknown',
};
export const controllingPersonsNationalitiesMasters: string[] = ['Indian', 'Others'];

//Application types
export enum APPLICATION_TYPE {
  INDIVIDUAL = 'individual',
  NON_INDIVIDUAL = 'non_individual',
}

export const AMC_APPROVER_CHECK_FOR_INDIVIDUAL = true;

export const ENABLE_EMAIL_OTP = true;

export const APPLICATION_STATUS_AMCAPPROVER_individual: { [key: string]: string } = {
  draft: 'Draft',
  sent_to_amc_approver: 'Sent to GIFT City Approver',
  sent_to_applicant1: 'Sent to 1st applicant',
  approved_by_applicant1: 'Approved by 1st Applicant',
  approved_by_applicant2: 'Approved by 2nd Applicant',
  approved_by_applicant3: 'Approved by 3rd Applicant',
  approved_by_trustee: 'Approved by Trustee',
  approved_by_fundmanager: 'Approved by investment manager',
  invitationexpired: 'Invitation Expired',
  completed: 'Completed',
  signed: 'Completed',
  rejected: 'Rejected',
};
export const IndividualApplicationStatusBasedOnRole: { [key: string]: { [key: string]: string } } =
  {
    [USER_ROLES.AMCAPPROVER]: {
      ...APPLICATION_STATUS_AMCAPPROVER_individual,
      sent_to_amc_approver: 'Pending',
    },
  };

export const APPLICATION_LISTING_STATUS: { [key: string]: string } = {
  draft: 'Draft',
  sent_to_applicant1: 'Sent to 1st applicant',
  draft_send_back: 'Draft(Send Back)',
  approved_by_applicant1: 'Approved by 1st Applicant',
  approved_by_applicant2: 'Approved by 2nd Applicant',
  approved_by_applicant3: 'Approved by 3rd Applicant',
  approved_by_trustee: 'Approved by Trustee',
  approved_by_fundmanager: 'Approved by investment manager',
  invitationexpired: 'Invitation Expired',
  completed: 'Completed',
  signed: 'Completed',
  rejected: 'Rejected',
  sent_to_poa_approver: 'Sent to POA approver',
  sent_to_amc_approver: 'Sent to GIFT City Approver',
  sent_to_authorised_signatories: 'Sent to authorised signatories',
  approved_by_authorised_signatories: 'Approved by authorised signatories',
};

export enum APPLICATION_TYPE_FOR_DOCUMENTS {
  INDIVIDUAL = 'individual',
  MINOR = 'minor',
  NON_INDIVIDUAL = 'non_individual',
  INDIVIDUAL_POA = 'individual_poa',
  NRI = 'nri',
  NRI_PIO = 'nri_pio',
  NRI_POA = 'nri_poa',
  NOMINEE_DOC = 'nominee',
  NOMINEE_GUARDIAN = 'nomineeGuardian',
  FOREIGN_NATIONAL = 'foreign_national', // POA implementation is pending.as of now foreign national not needed.
}
export const BankAccountTypeMaster: { [key: string]: string } = {
  Current: 'Current',
  Savings: 'Savings',
  // Drawdown: 'Drawdown',
};
export const NRIBankAccountTypeMaster: { [key: string]: string } = {
  NRE: 'NRE',
  NRO: 'NRO',
  FCNR: 'FCNR',
};
export const BankAccountTypeForVenture: { [key: string]: string } = {
  ...BankAccountTypeMaster,
  ...NRIBankAccountTypeMaster,
};

export const InboundDomesticBankAccountTypeMaster: { [key: string]: string } = {
  // Savings: 'Savings',
  NRE: 'NRE',
  // NRO: 'NRO',
};

export const InboundOverseasBankAccountTypeMaster: { [key: string]: string } = {
  NRE: 'NRE',
  // NRO: 'NRO',
  FCNR: 'FCNR',
};

export const DistributorTypesForUserManageMent: { [key: string]: string } = {
  Individual: 'individual',
  Company: 'company',
};
export const _DistributorTypesForUserManageMent: { [key: string]: string } = {
  individual: 'Individual',
  company: 'Company',
};

export const ENABLE_KRA_DOCUMENT_FETCH = true;

export const SALT = 'F2lNZWFxUH';
export const SALT2 = 'WTVPJel6dTGVocF';

export const ONBOARDING_OPTIONS: { [key: string]: string } = {
  otp: 'OTP',
  email_consent: 'Email Consent',
};

export const EmailConsentStatusMaster: { [key: string]: string } = {
  pending: 'Pending',
  rejected: 'Rejected',
  approved: 'Approved',
  revoked: 'Revoked',
};

export const ENABLE_Email_Consent = true;

export const ONBOARDING_INVESTOR: { [key: string]: string } = {
  individual: 'Individual',
  non_individual: 'Non Individual',
};

export const ACCOUNT_TYPE_MASTER: { [key: string]: string } = {
  normal: 'Normal',
  minor: 'Minor',
};

export const IdTypeMasters: string[] = ['TIN', 'OTHERS'];

export const ReasonMaster: { [key: string]: { code: string; description: string } } = {
  reason_a: {
    code: 'Reason A',
    description:
      'The country where the Account Holder is liable to pay tax does not issue TIN to its residents.',
  },
  reason_b: {
    code: 'Reason B',
    description:
      'No TIN required [Select this reason only if the authorities of the respective country of tax residence do not required the TIN to be collected].',
  },
  reason_c: { code: 'Reason C', description: 'Please specify incase there is anyother reason.' },
};

export const SourceOfFundsMaster: { [key: string]: string } = {
  bussiness_profits: 'Business profits or dividends',
  employement_income: 'Income from employment',
  sale_business_partnership: 'Sale of business or partnership',
  inheritance: 'Inheritance',
  royalties: 'Royalties',
  investments: 'Investments',
  gift: 'Gift',
  compensatio_payment: 'Compensation payment',
  sale_property: 'Sale of property',
  lottry_betting_casino: 'Lottery/betting/casino winnings',
  savings: 'Savings',
  other: 'Other',
};

export const ApplicationSourceMaster: { [key: string]: string } = {
  migration: 'Migration',
  digitalonboarding: 'New Digital Onboarding',
};

export const defaultCurrency = 'usd';
export const CurrencyMaster: { [key: string]: { currency: string } } = {
  inr: { currency: 'INR' },
  usd: { currency: 'USD' },
};

export const timeZoneFromServer = 'Asia/Kolkata';

export const INDIVIDUAL_ID_TYPES_MASTER: { [key: string]: string } = {
  passport_id: 'Passport ID',
  residential_id: 'Residential ID',
  tax_id: 'Tax ID',
  citizen_card: 'Citizen Card',
};

export const NON_INDIVIDUAL_ID_TYPES_MASTER: { [key: string]: string } = {
  corporate_identification_number: 'CIN (Corporate Identification Number)',
  business_registration_number: 'Business Registration Number',
  firm_registration_number: 'Firm Registration Number',
  tax_identification_number: 'Tax Identification Number',
};

export const ONBOARDING_ID_TYPES_MASTER: { [key: string]: string } = {
  ...INDIVIDUAL_ID_TYPES_MASTER,
  ...NON_INDIVIDUAL_ID_TYPES_MASTER,
  others: 'Others',
};

//SAVE_LATER_VALIDATION_CHECK if false then Mandatory fields for Document Section will be Verified only on Clicking Preview
export const SAVE_LATER_VALIDATION_CHECK = false;

export const relatedRelations = ['MOTHER', 'FATHER', 'DAUGHTER', 'SON', 'SPOUSE', 'OTHERS'];
export const relatedRelationsXalt = ['MOTHER', 'FATHER', 'GRANDFATHER', 'LEGAL GUARDIAN'];

export const isNaturalParent: { [key: string]: string } = {
  yes: 'Yes',
  no: 'No',
};

export const yesNoMaster: { [key: string]: string } = {
  yes: 'Yes',
  no: 'No',
};

export const feeTypeMaster: { [key: string]: string } = {
  fixed: 'Fixed',
  variable: 'Variable',
};
export const flowTypeMaster: { [key: string]: string } = {
  true: 'Outbound', // Investor with pan
  false: 'Inbound', // Investor without pan
};

export const investmentPlanTypeMaster: { [key: string]: string } = {
  regular: 'Regular Plan',
  direct: 'Direct Plan',
};
// export const RTAApproverSendBackRoles: { [key: string]: string } = {
//   maker: 'Maker',
//   amcapprover: 'AMC Approver',
// };

// export const ENABLE_RTA_APPROVER = false;

export const COMMENT_ROLES: { [key: string]: string } = {
  rm: 'RM',
  distributor: 'Distributor',
  subdistributor: 'Sub Distributor',
  amcapprover: 'AMC Approver',
  poaapprover: 'POA Approver',
  rtaapprover: 'GIFT City Approver',
};

export const IS_STAMP_PAPER_SERIES_MASTER: { [key: string]: string } = {
  true: 'Yes',
  false: 'No',
};

export const STAMP_SERIES_TYPE_MASTER: { [key: string]: string } = {
  single: 'Single Stamp Series',
  multi: 'Multi Stamp Series',
};

export const DOCUMENT_ALLOW_PASTE = false;
export const ENABLE_USER_EXPORT = true;

export const FLOW_TYPE_MASTER: { [key: string]: string } = {
  investor_with_pan: 'Investor with PAN',
  investor_without_pan: 'Investor without PAN',
};

export const onboardingTypeMasters: { [key: string]: string } = {
  normal: 'Normal',
  minor: 'Minor',
};

export const INVESTOR_WITH_PAN = true;
export const INVESTOR_WITHOUT_PAN = true;

export const docInvalidCheck =
  'Please upload a file that meets the size and format requirements, and ensure it is not password protected.';

export const AdditionalKYCAndFatcaDeclarationUpdateDate = '2025-05-13';

export const BankBranchMandatoryDate = '2025-10-14';

export const taxResidencyDocumentTypeMaster: { [key: string]: string } = {
  '10f_trc': '10F/TRC',
  declaration_by_non_resident: 'Declaration by Non-Resident',
};

export const servicesMaster: { [key: string]: string } = {
  isForeignExchange: 'Foreign Exchange/ Money Changer Services',
  isMoneyLending: 'Money Lending/ Pawning',
  isGamingOrGambling: 'Gaming/ Gambling/ Lottery/ Casino Services',
  isNoneOfThese: 'None Of the above',
};
export const RiskProfileEnabled = false;

export const FUND_FLOW_TYPE_MASTER: { [key: string]: string } = {
  inbound: 'Inbound',
  outbound: 'Outbound',
};

export const bankType: { [key: string]: string } = {
  Domestic: 'Domestic',
  Overseas: 'Overseas',
};

export const ENABLE_RTA_APPROVER = false;

export const bulkUsersType: { [key: string]: string } = {
  download: '--- select user for download template ---',
  rm: 'Relationship Managers',
  individual_distributor: 'Individual Distributors',
  company_distributor: 'Company Distributors',
  distributorRm: "Distributor's RM",
  authorisedSignatory: 'Authorised Signatory',
  poaApprover: 'POA Approver',
  trustee: 'Trustees',
  investmentManager: 'Investment Managers',
  rtaApprover: 'GIFT City Approvers',
  amcAdmins: 'AMC Admins',
};
export const USPersonDateValidation = '2026-01-21';

export const MASTER_DESIGNATION: { [key: string]: string } = {
  promoter: 'Promoter',
  partner: 'Partner',
  karta: 'Karta',
  director: 'Director',
  trustee: 'Trustee',
  committee: 'Commitee',
  other: 'Other',
};

export const KBOLT_XALT_MASTER: { [key: string]: string } = {
  KBOLT: 'kbolt',
  XALT: 'xalt',
  KBOLT_XALT: 'kbolt_xalt',
};

export const AOI_BOI_MASTER: { [key: string]: string } = {
  aop: 'AOP',
  boi: 'BOI',
};

export const STATE_MASTER: string[] = [
  'Jammu and Kashmir',
  'Himachal Pradesh',
  'Punjab',
  'Chandigarh',
  'Uttarakhand',
  'Haryana',
  'Delhi',
  'Rajasthan',
  'Uttar Pradesh',
  'Bihar',
  'Sikkim',
  'Arunachal Pradesh',
  'Assam',
  'Manipur',
  'Mizoram',
  'Tripura',
  'Meghalaya',
  'Nagaland',
  'West Bengal',
  'Jharkhand',
  'Orissa',
  'Chhattisgarh',
  'Madhya Pradesh',
  'Gujarat',
  'Daman and Diu',
  'Dadra and Nagar Haveli',
  'Maharashtra',
  'Andhra Pradesh',
  'Karnataka',
  'Goa',
  'Lakshadweep',
  'Kerala',
  'Tamil Nadu',
  'Puducherry',
  'Andaman and Nicobar Islands',
  'Telangana',
];

export const otherRelations = [
  'Husband',
  'Wife',
  'Cousin',
  'Father-in-law',
  'Sister-in-law',
  'Brother-in-law',
  'Mother-in-law',
  'Grandson',
  'Spouse',
  'Son-in-law',
  'Daughter-in-law',
  'Friend',
  'Uncle',
  'Aunt',
  'Nephew',
  'Niece',
  'Grand Daughter',
  'Grand Mother',
  'Grand Father',
];

export const JOURNEY_TYPE: { [key: string]: string } = {
  CVL_KRA: 'CVL KRA',
  CKYC: 'CKYC',
};
export const PaymentMaster: { [key: string]: string } = {
  online: 'Online',
  offline: 'Offline',
};

export const ESIGN_MESSAGE =
  'Please check your email box for further communication after completing e-sign';
export const nomineeIDProofHideDate = '2026-07-14';

export const OUTBOUND_BANK_ACC_TYPE_CHANGE_DATE = '2026-08-05';
export const INBOUND_BANK_ACC_TYPE_CHANGE_DATE = '2026-08-25';

export const KYC_VALIDATION_START_DATE = '2026-09-10';
